import { render, staticRenderFns } from "./PrivilegeClubSection.vue?vue&type=template&id=372e2242&scoped=true"
import script from "./PrivilegeClubSection.vue?vue&type=script&lang=js"
export * from "./PrivilegeClubSection.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeClubSection.vue?vue&type=style&index=0&id=372e2242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372e2242",
  null
  
)

export default component.exports